import {
  getLoadingDots,
  getMessageFeed,
} from '@/components/chatbot/chatbotElementUtils';
import { autoScrollToBottom } from '@/components/chatbot/chatbotButtonsAndFormsController';

function moveLoadingDotsToBottomOfFeed() {
  const dots = getLoadingDots();
  const feed = getMessageFeed();

  feed.appendChild(dots);
}

function showLoadingDots() {
  const dots = getLoadingDots();
  dots.ariaHidden = false;
  moveLoadingDotsToBottomOfFeed();

  dots.classList.remove('solv-chatbot-widget--hidden');
  autoScrollToBottom(); // loading get cut off when this isn't called here
}

function hideLoadingDots() {
  const dots = getLoadingDots();
  dots.ariaHidden = true;
  dots.classList.add('solv-chatbot-widget--hidden');
}

export { showLoadingDots, hideLoadingDots };
